import templateUrl from "emun.swatch/swatch-view.htm";
import controller from "emun.swatch/swatch-view.controller";
import "emun.swatch/swatch-view.client.scss";

export default {
  bindings: {
    swatchId: "@",
    size: "@",
    zoomSize: "@",
    mode: "@",
  },
  require: {
    container: "^swatchContainer",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
